import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { isNil } from "lodash";
import { DateUnionType, DateUtils } from "~app/common/utils/date-utils";

export class DateValidators {
    static minDate(date: DateUnionType): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if(isNil(control.value)) {
                return null;
            }

            // Jämför datum på "day"-nivå för att ignorera tid och tidszon.
            if (DateUtils.isBeforeByDay(control.value, date)) {
                return { greaterThan: true };
            }

            return null;
        };
    }

    static maxDate(date: DateUnionType): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if(isNil(control.value)) {
                return null;
            }

            // Jämför datum på "day"-nivå för att ignorera tid och tidszon.
            if (DateUtils.isAfterByDay(control.value, date)) {
                return { lessThan: true };
            }

            return null;
        };
    }
}
